import { newId } from "@/db/dexie";

/**
 * Welche Familie gerade gilt und wer schreibt.
 *
 * Solange keine Supabase-Instanz konfiguriert ist, gehört alles einer lokalen
 * Familie, die nur auf diesem Gerät existiert. Sobald eine Anmeldung besteht,
 * setzt die App die echte family_id, und die lokal angelegten Zeilen bleiben
 * liegen, statt in eine fremde Familie zu wandern.
 */
const FAMILY_KEY = "ainkauf.local.family_id";
const MEMBER_KEY = "ainkauf.local.member_id";
const ACTIVE_FAMILY_KEY = "ainkauf.active.family_id";
const ACTIVE_USER_KEY = "ainkauf.active.user_id";
const ADOPTED_KEY = "ainkauf.active.adopted";

function readOrCreate(key: string): string {
  const existing = globalThis.localStorage?.getItem(key);
  if (existing) return existing;
  const created = newId();
  globalThis.localStorage?.setItem(key, created);
  return created;
}

export function localFamilyId(): string {
  return readOrCreate(FAMILY_KEY);
}

export function localMemberId(): string {
  return readOrCreate(MEMBER_KEY);
}

/** Familie, in die geschrieben wird. Ohne Anmeldung die lokale. */
export function activeFamilyId(): string {
  return globalThis.localStorage?.getItem(ACTIVE_FAMILY_KEY) ?? localFamilyId();
}

/**
 * Wer schreibt. Das ist das Konto aus auth.users, nicht die Mitgliedszeile:
 * items.created_by und items.checked_by zeigen in der Datenbank auf
 * auth.users. Ohne Anmeldung gilt eine lokale Kennung, die nie hochgeladen
 * wird.
 */
export function activeUserId(): string {
  return globalThis.localStorage?.getItem(ACTIVE_USER_KEY) ?? localMemberId();
}

export function setActiveIdentity(familyId: string, userId: string): void {
  globalThis.localStorage?.setItem(ACTIVE_FAMILY_KEY, familyId);
  globalThis.localStorage?.setItem(ACTIVE_USER_KEY, userId);
}

export function clearActiveIdentity(): void {
  globalThis.localStorage?.removeItem(ACTIVE_FAMILY_KEY);
  globalThis.localStorage?.removeItem(ACTIVE_USER_KEY);
  globalThis.localStorage?.removeItem(ADOPTED_KEY);
}

/** Merkt sich, dass die lokalen Daten schon in eine Familie übernommen wurden. */
export function adoptionDone(familyId: string): boolean {
  return globalThis.localStorage?.getItem(ADOPTED_KEY) === familyId;
}

export function markAdoptionDone(familyId: string): void {
  globalThis.localStorage?.setItem(ADOPTED_KEY, familyId);
}
